import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as OverviewActions from '../../store/actions/overview.actions';
import {
  getTotalNumberOfOffers,
  getTotalNumberOfRequests,
} from '../../store/selectors/overview.selector';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
  standalone: false,
})
export class TableHeaderComponent {
  private readonly store = inject(Store);

  totalNumberOfOffers$: Observable<number>;
  totalNumberOfRequests$: Observable<number>;

  constructor() {
    this.totalNumberOfOffers$ = this.store.select(getTotalNumberOfOffers);
    this.totalNumberOfRequests$ = this.store.select(getTotalNumberOfRequests);
  }

  tabChange(index: number): void {
    if (index === 0) {
      this.store.dispatch(OverviewActions.switchToManureOffersOverview());
    } else if (index === 1) {
      this.store.dispatch(OverviewActions.switchToManureRequestsOverview());
    }
  }
}
